import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import Shell from 'shell';
import './styles/index.scss';

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <Shell />
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

function removeRedundantIframes() {
  const iframes = document.querySelectorAll('iframe');
  iframes.forEach(iframe => {
    if (iframe.getAttribute('id') !== 'raychat_widget') {
      iframe.remove();
    }
  });
}

window.addEventListener('load', () => {
  removeRedundantIframes();
  setTimeout(removeRedundantIframes, 1500);
});
